export default __webpack_public_path__ + "static/media/img-time-km-be_fr@3x.3a0b0561.png";